import { settings } from "../app";
import Mutex from "../server/Mutex";
import {
  getAccessToken,
  removeAccessToken,
  getRefreshToken,
  setTokens,
  refreshSessionString,
  accessResponseString,
  refreshResponseString,
  removeTokens,
} from "./security/securityUtils";

export const getToken = () => {
  return `${getAccessToken()}`;
};

let mutex = new Mutex();

export const refreshToken = async ({ callback }) => {
  const refreshTokenValue = getRefreshToken();
  if (!refreshTokenValue) {
    removeTokens();
    // eslint-disable-next-line no-throw-literal
    throw { ok: false, url: "/refresh" };
  }
  const currentAuth = getAccessToken();

  let unlock = await mutex.lock();

  if (currentAuth === getAccessToken()) {
    removeAccessToken();
    let body = {};
    body[refreshSessionString] = refreshTokenValue;
    const res = await fetch(`${settings.authorizationApi}/refresh`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    if (!res.ok) {
      unlock();
      throw res;
    }

    const data = await res.json();
    if (data[accessResponseString]) {
      setTokens(data[accessResponseString], data[refreshResponseString]);
      unlock();
    } else {
      unlock();
      throw res;
    }
  } else {
    unlock();
  }

  return await callback();
};
